module.exports = __webpack_public_path__ + "static/media/about_card_image3.b96f9ada.png";